import { render, staticRenderFns } from "./CreateNewMortgageStatusModal.vue?vue&type=template&id=2561e5dd"
import script from "./CreateNewMortgageStatusModal.vue?vue&type=script&lang=js"
export * from "./CreateNewMortgageStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports